import { ResumedLeadState } from '../context';

/**
 * Single source of truth for determining if a lead can pick their own schedule or use prefilled one
 */

export const leadCanPickSchedule = ({
  resumedLeadState,
  isEvalAllowed,
}: {
  resumedLeadState?: ResumedLeadState;
  isEvalAllowed?: boolean;
}) => {
  if (resumedLeadState?.prefilledAppointment) {
    return { allowed: false, reason: 'Prefilled appointment' };
  }

  if (!isEvalAllowed) {
    return { allowed: false, reason: 'Cannot schedule evaluation' };
  }

  return { allowed: true, reason: 'Default exclusion reason' };
};
